import { render, staticRenderFns } from "./messagePromptList.vue?vue&type=template&id=1f8275b4&scoped=true"
import script from "./messagePromptList.vue?vue&type=script&lang=js"
export * from "./messagePromptList.vue?vue&type=script&lang=js"
import style0 from "./messagePromptList.vue?vue&type=style&index=0&id=1f8275b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8275b4",
  null
  
)

export default component.exports